<template>
  <v-container>
    <v-progress-linear
      :value=" (quizScore / quiz.length) * 100"
      color="amber"
      rounded
      height="25">
      <div
        class="subtitle-2 font-weight-light"
        style="position: absolute; left: 5px;">
        {{ $t('quiz.nb') }}: {{ slide + 1 }} / {{ quiz.length }}
      </div>
      <div
        class="subtitle-2 font-weight-light"
        style="position: absolute; right: 5px;">
        {{ $t('quiz.score') }}: {{ quizScore }} / {{ quiz.length }}
      </div>
    </v-progress-linear>
    <v-carousel
      v-if="hasMinWords"
      light
      hide-delimiters
      :show-arrows="false"
      touchless
      v-model="slide">
      <v-carousel-item v-for="(item, index) in quiz" :key="index">
        <QuizContainer
          :question="item.question"
          :options="item.options"
          :answer="item.answer"
          :score="`${quizScore} / ${quiz.length}`"
          :performance="(quizScore / quiz.length)"
          :slide="slide"
          @next:slide="slide++"
          :last-slide="lastSlide" />
      </v-carousel-item>
    </v-carousel>
    <p v-else class="red--text pt-6">
      {{ $t('quiz.notEnoughWords') }}
    </p>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import QuizContainer from './quiz_container';

export default {
  name: 'QuizManager',
  components: {
    QuizContainer,
  },
  data: () => ({
    slide: 0,
    quiz: [],
    hasMinWords: false,
  }),
  computed: {
    ...mapGetters('current', ['quizScore', 'languageSet']),
    ...mapGetters('vocabularies', ['vocabularyList']),

    lastSlide() {
      return this.slide === this.quiz.length - 1;
    },
  },
  methods: {
    createQuiz() {
      const getRandomWords = (list, amount) => {
        if (amount > list.length) {
          this.hasMinWords = false;
          return false;
        }

        this.hasMinWords = true;

        const words = [];
        const getRandomWord = () => {
          const randomNumber = this._.random(0, list.length - 1);
          const randomWord = list[randomNumber];

          if (words.length === 3) {
            return;
          }

          if (!words.includes(randomWord)) {
            words.push(randomWord);
          }

          getRandomWord();
        };

        getRandomWord();

        return words;
      };

      this.quiz = this.vocabularyList.vocabularies.map((pair) => {
        const { baseLanguage } = this.languageSet;
        const { learningLanguage } = this.languageSet;

        const learningWords = this.vocabularyList.vocabularies.map((item) => item[learningLanguage]);
        const learningWordsWithoutAnswer = learningWords.filter((item) => item !== pair[learningLanguage]);

        return {
          question: pair[baseLanguage],
          options: [pair[learningLanguage], ...getRandomWords(learningWordsWithoutAnswer, 3) || []],
          answer: pair[learningLanguage],
        };
      });
    },
  },

  created() {
    this.createQuiz();
  },
};
</script>
